import { render, staticRenderFns } from "./MasonryLayout.vue?vue&type=template&id=688b675e&scoped=true&"
import script from "./MasonryLayout.vue?vue&type=script&lang=js&"
export * from "./MasonryLayout.vue?vue&type=script&lang=js&"
import style0 from "./MasonryLayout.vue?vue&type=style&index=0&id=688b675e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b675e",
  null
  
)

export default component.exports